module.exports = __webpack_public_path__ + "img/sports.616daed7.png";